/** @format */
import angular from 'angular';
export const searchEventConstantModule = 'sis-component.search.searchEvent';
angular.module(searchEventConstantModule, []).constant('SEARCH_EVENT', {
  SEARCH_AGAIN: 'SEARCH_AGAIN'
});